import { onActivated, onDeactivated, ref } from 'vue';

export const useIsViewActive = () => {
    const isActive = ref(true);

    onActivated(() => {
        isActive.value = true;
    });
    onDeactivated(() => {
        isActive.value = false;
    });

    return isActive;
};
